export const getNamPersonalLoansCalculator = (state) => state.namPersonalLoansCalculator;
